"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseSectionsListCustomization = exports.parseSectionCustomization = exports.parseElementCustomization = void 0;

var _SectionCustomizationParser = _interopRequireDefault(require("./SectionCustomizationParser"));

var _ElementCustomizationParser = _interopRequireDefault(require("./ElementCustomizationParser"));

var _sectionElementsUtils = require("../sectionElementsUtils");

var _excluded = ["customizationJson"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var sectionCustomizationParser = new _SectionCustomizationParser.default();
var elementCustomizationParser = new _ElementCustomizationParser.default();

var parse = function parse(parser, _ref, options) {
  var customizationJson = _ref.customizationJson,
      modelAttributes = _objectWithoutProperties(_ref, _excluded);

  var parsedData = parser.parse(modelAttributes.customizationVersion, customizationJson, options);
  var parsedAttributes = {};

  if (parsedData.version) {
    parsedAttributes.customizationVersion = parsedData.version;
  }

  if (parsedData.data) {
    parsedAttributes.customization = parsedData.data;
  }

  return _objectSpread(_objectSpread({}, modelAttributes), parsedAttributes);
};

var parseSectionCustomization = function parseSectionCustomization(sectionAttributes) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return parse(sectionCustomizationParser, sectionAttributes, options);
};

exports.parseSectionCustomization = parseSectionCustomization;

var parseElementCustomization = function parseElementCustomization(elementAttributes) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return parse(elementCustomizationParser, elementAttributes, options);
};

exports.parseElementCustomization = parseElementCustomization;

var parseSectionsListCustomization = function parseSectionsListCustomization(sectionsList) {
  return sectionsList.map(function (section) {
    return _objectSpread(_objectSpread({}, parseSectionCustomization(section)), {}, {
      elements: (0, _sectionElementsUtils.mapElementsJson)(section.elements, function (element) {
        return parseElementCustomization(element);
      })
    });
  });
};

exports.parseSectionsListCustomization = parseSectionsListCustomization;